import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { lerp } from '@lemonade-hq/ts-helpers';
import Image from 'next/image';
import type React from 'react';
import styled, { css } from 'styled-components';

interface HouseProps {
  houseBg: string;
  houseBgMobile: string;
  houseOpacity: number;
  houseZindex: number;
  houseTranslateY: number;
  houseTranslateMobile: number;
  houseScale: number;
  houseScaleMobile: number;
  houseLerp: number;
  houseTop: string[];
  houseLeft: string;
  altText?: string;
}

const HouseSmallScreen = css`
  @media (min-width: 768px) and (max-width: 1450px) and (max-height: 767px) {
    width: 2088px;
    height: 1123px;
  }
`;

const HouseElement = styled(Flex)<HouseProps>`
  left: ${(props: { houseLeft: string }): string => `${props.houseLeft}`};

  ${MEDIA_QUERIES.tabletAndDesktop`
        left: auto;
    `}

  ${HouseSmallScreen}
`;

const HouseElementDesktop = styled(HouseElement)`
  display: none;
  ${MEDIA_QUERIES.tabletAndDesktop`
        display: flex;
    `}
`;
const HouseElementMobile = styled(HouseElement)`
  display: flex;
  ${MEDIA_QUERIES.tabletAndDesktop`
        display: none;
    `}
`;

const HouseImage = styled(Image)`
  ${HouseSmallScreen}
`;

const House: React.FC<HouseProps> = ({
  houseTop,
  houseLeft,
  houseBg,
  houseBgMobile,
  houseZindex,
  houseOpacity,
  houseScale,
  houseScaleMobile,
  houseTranslateY,
  houseTranslateMobile,
  houseLerp,
  altText = 'Lemonade home insurance',
}) => {
  const translateYFn = (val: number): number => lerp(0, val, houseLerp);
  const scaleFn = (val: number): number => lerp(1, val, houseLerp);

  const styleFn = (translate: number, scale: number) => ({
    transform: `translateY(${translateYFn(translate)}px) scale(${scaleFn(scale)})`,
  });

  return (
    <>
      <HouseElementDesktop
        style={styleFn(houseTranslateY, houseScale)}
        top={houseTop}
        houseLeft={houseLeft}
        opacity={houseOpacity}
        zIndex={houseZindex}
        position="absolute"
        width={2576}
        height={1386}
      >
        <HouseImage src={houseBg} width={2576} height={1386} alt={altText} priority />
      </HouseElementDesktop>
      <HouseElementMobile
        style={styleFn(houseTranslateMobile, houseScaleMobile)}
        top={houseTop}
        houseLeft={houseLeft}
        opacity={houseOpacity}
        zIndex={houseZindex}
        position="absolute"
        width={2576}
        height={1386}
      >
        <HouseImage src={houseBgMobile} width={2576} height={1386} alt={altText} priority />
      </HouseElementMobile>
    </>
  );
};

export default House;
